export default function PHP_try() {
  return (
    <div>
      <h1>PHP_try</h1>
    </div>
  );
}
